















































































































































































import Vue from "vue"
import {
  collectionRequestService,
  ICollectionRequestService
} from "@/model/service/collection-request/collection-request-service.ts"
import { CollectionRequest } from "@/model/entity/collection-request/collection-request"
import moment from "moment"
import Datatable, { DatatableOptions, FilterContainer, IDatatable } from "@/components/datatable/Datatable.vue"
import {FieldDescription, FieldTypeEnum} from "@/model/entity/field-descriptor"
import NewCollectionRequest from "@/pages/collection-request/new-collection-request/NewCollectionRequest.vue"
import { colReqStatusEnum, ColReqStatusEnum } from "@/model/enum/col-req-status-enum"
import { ParcelStatusEnum, parcelStatusEnumList } from "@/model/enum/parcel-status-enum.ts"
import { ParcelAdditionalStatusEnum, parcelAdditionalStatusEnumList } from "@/model/enum/parcel-additional-status-enum"
import {DpdProduct} from "@/model/new-parcel-model/dpd-product/dpd-product"
import {plainToClass} from "class-transformer"
import {Filter} from "@/model/dto/filter"
import {PickupDiffStatusEnum, pickupDiffStatusEnumList} from "@/model/enum/pickup-diff-status-enum"
import { FilterOptionEnum, filterOptionList } from "@/model/util/filter-option/filter-option-enum"
import filterOptions from "@/model/util/filter-option/filter-option"
import { DpdProductVariant } from "@/model/new-parcel-model/dpd-product/dpd-product-variant"

interface ListCollectionRequestData {
  dpdProducts: DpdProductVariant[] | null
  collectionRequestService: ICollectionRequestService
  options: DatatableOptions
  fields: FieldDescription[]
  filters: FilterContainer
  selectedItems: CollectionRequest[]
  dialogVisible: boolean
  selectedProduct: DpdProductVariant | null | undefined
  selectedColReq: CollectionRequest | null
  colReqStatusEnumList: ColReqStatusEnum[]
  parcelStatusEnumList: ParcelStatusEnum[]
  additionalParcelStatusEnumList: ParcelAdditionalStatusEnum[]
  pickupDiffStatusEnumList: PickupDiffStatusEnum[]
  filterOptionList: FilterOptionEnum[]
  option: FilterOptionEnum
}

export default Vue.extend({
  components: { Datatable, NewCollectionRequest },
  mixins: [ filterOptions ],
  data(): ListCollectionRequestData {
    return {
      dpdProducts: null,
      options: {
        operations: {
        }
      },
      selectedItems: [],
      fields: CollectionRequest.getFieldDescriptionList(),
      collectionRequestService: collectionRequestService,
      filters: {
        createdDate: [
          moment()
            .startOf("day")
            .toDate(),
          moment()
            .endOf("day")
            .toDate()
        ]
      },
      dialogVisible: false,
      selectedProduct: null,
      selectedColReq: null,
      colReqStatusEnumList: colReqStatusEnum,
      parcelStatusEnumList: parcelStatusEnumList,
      additionalParcelStatusEnumList: parcelAdditionalStatusEnumList,
      pickupDiffStatusEnumList: pickupDiffStatusEnumList,
      option: filterOptionList[0],
      filterOptionList: filterOptionList
    }
  },
  methods: {
    getAdditionalStatus(codes: string) {
      if (notEmpty(codes)) {
        return codes
          .split(/[,;]/)
          .map(code => this.additionalParcelStatusEnumList.find(parcelStatus => parcelStatus.code === Number(code)))
      }
      return []
    },
    getStatusI18n(value: string) {
      const statusEnum = this.colReqStatusEnumList.find(status => status.name === value)
      if (exists(statusEnum)) {
        return statusEnum!.i18nKey
      }
      return this.colReqStatusEnumList.find(status => status.name === "UNKNOWN")!.i18nKey
    },
    getStatusDate(date: any) {
      return moment(new Date(date)).format("DD.MM.YYYY HH:mm")
    },
    getParcelStatusI18n(status: number) {
      const parcelStatusEnum = this.parcelStatusEnumList.find(parcelStatus => parcelStatus.value === status)
      if (exists(parcelStatusEnum)) {
        return parcelStatusEnum!.i18nKey
      }
      return this.parcelStatusEnumList.find(parcelStatus => parcelStatus.name === "UNKNOWN")!.i18nKey
    },
    async showDetails(collectionRequest: CollectionRequest) {
      this.dialogVisible = true
      await this.getDpdProductVariants(collectionRequest.deliveryAddress.country.id)
      this.selectedProduct = this.dpdProducts!.find(product =>
              product.serviceCode === Number(collectionRequest.serviceCode) ||
              product.serviceBackCode === Number(collectionRequest.serviceCode)
      )
      this.selectedColReq = collectionRequest
    },
    toggleEmployeeFilter(value: boolean) {
      if (value) {
        if (!exists(this.filters.employee)) {
          this.$set(this.filters, "employee", this.$store.getters.loggedUser.username)
        } else {
          this.filters.employee = this.$store.getters.loggedUser.username
        }
      } else {
        this.filters.employee = ""
      }
      const datatable = this.$refs.datatable as IDatatable
      datatable.refreshData()
    },
    filterChange(dates: Date[]) {
      if (exists(dates)) {
        dates[0] = moment(dates[0])
          .startOf("day")
          .toDate()
        dates[1] = moment(dates[1])
          .endOf("day")
          .toDate()
      }
      if (!exists(this.filters.createdDate)) {
        this.$set(this.filters, "createdDate", dates)
      } else {
        this.filters.createdDate = dates
      }
      const datatable = this.$refs.datatable as IDatatable
      datatable.refreshData()
    },
    geodata(colReqs: CollectionRequest[]) {
      const vm = this
      vm.startLoad()
      vm.collectionRequestService
        .geodata(colReqs.map(parcel => parcel.id!))
        .then(response => {
          vm.handleFileResponse(response)
          vm.endLoad()
        })
        .catch(() => {
          vm.endLoad()
        })
    },
    handleFileResponse(response: any) {
      const filename = response.headers["content-disposition"].match(/attachment; filename=(.*)/)[1]
      const contentType = response.headers["content-type"]
      const blob = new Blob([response.data], { type: contentType })
      saveAs(blob, filename)
    },
    exportFile() {
      const vm = this
      vm.startLoad()
      const filters: Filter[] = []
      vm.fields
        .filter(field => exists(vm.filters[field.fieldName!]) && vm.filters[field.fieldName!].toString().length > 0)
        .forEach(field => {
          if (field.fieldType === FieldTypeEnum.DATE) {
            filters.push(new Filter(field.fieldName! + "From", vm.filters[field.fieldName!][0].getTime()))
            filters.push(new Filter(field.fieldName! + "To", vm.filters[field.fieldName!][1].getTime()))
          } else {
            filters.push(new Filter(field.fieldName!, vm.filters[field.fieldName!]))
          }
        })
      if (exists(vm.filters["company"]) && vm.filters["company"] !== "") {
        filters.push(new Filter("company", vm.filters["company"]))
      } else if (exists(vm.filters["office"]) && vm.filters["office"] !== "") {
        filters.push(new Filter("office", vm.filters["office"]))
      } else if (exists(vm.filters["employee"]) && vm.filters["employee"] !== ""
          && !exists(vm.fields[vm.fields.findIndex(f => f.fieldName === "employee")])) {
        filters.push(new Filter("employee", vm.filters["employee"]))
      }
      this.collectionRequestService
          .exportWithFilters(filters)
          .then((response: any) => {
              vm.endLoad()
              vm.handleFileResponse(response)
          })
          .catch(() => vm.endLoad())
    },
    rowSelectable(collectionRequest: CollectionRequest) {
      return (new Date().getTime() - 1000 * 60 * 20) < new Date(collectionRequest.createdDate!).getTime()
        && collectionRequest.statusId === 1
    },
    cancel(collectionRequests: CollectionRequest[]) {
      const vm = this
      vm.startLoad()
      vm.collectionRequestService
      .cancel(collectionRequests.map(collectionRequest => collectionRequest.id!))
      .then(response => {
        vm.endLoad()
        if (response.data.notCancelledCollectionRequests.length === 0) {
          vm.$message({
            message: vm.$t("collection_request.cancellation_successful").toString(),
            type: "success"
          })
        } else {
          let returnMessage = vm.$t("collection_request.cancellation_failed").toString()
          response.data.notCancelledCollectionRequests.forEach(
              collectionRequest => {
                returnMessage = returnMessage.concat(collectionRequest.reference + ", ")
              }
          )
          returnMessage = returnMessage.substring(0, returnMessage.length - 2)
          vm.$message({
            message: returnMessage,
            type: "error"
          })
        }
      })
      .catch(error => {
        vm.endLoad()
        vm.$error(error.message)
      })
    },
    updateFilterOption(option: FilterOptionEnum) {
      switch (option.value) {
        case 1:
          this.$set(this.filters, "office", this.$store.getters.loggedUser.office.id)
          this.filters.employee = ""
          this.filters.company = ""
          break
        case 2:
          this.$set(this.filters, "employee", this.$store.getters.loggedUser.username)
          this.filters.office = ""
          this.filters.company = ""
          break
        case 3:
          this.$set(this.filters, "company", this.$store.getters.loggedUser.office.company.id)
          this.filters.office = ""
          this.filters.employee = ""
          break
      }
      const datatable = this.$refs.datatable as IDatatable
      datatable.refreshData()
    },
    getDpdProductVariants(countryId: number) {
    this.$http.get(`/product/active_collection_request_products/${countryId}`).then(res => {
      this.dpdProducts = plainToClass(DpdProductVariant, res.data)
    })
  }
  },
  created() {
    const vm = this
    this.$nextTick(() => this.updateFilterOption(this.option))
  }
})
